/**
 * 2007-2017 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2017 PrestaShop SA
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import 'bootstrap/js/src/util';
import 'bootstrap/js/src/alert';
import 'bootstrap/js/src/button';
import  '../node_modules/bootstrap/js/src/collapse.js';
import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/dropdown';
import 'bootstrap/js/src/modal';
import 'bootstrap/js/src/popover';
import 'bootstrap/js/src/tab';
import 'bootstrap/js/src/toast';
import 'bootstrap/js/src/tooltip';
import 'bootstrap-touchspin';
import './lib/slick.min';
import './lib/jquery.hoverIntent.min';
import SlickSlider from './components/slick';

import './responsive';
import './checkout';
import './customer';
import './listing';
import './product';
import './cart';

import Form from './components/form';
import TopMenu from './components/top-menu';

import prestashop from 'prestashop';
import EventEmitter from 'events';


import './components/block-cart';
// import lazysizes from 'lazysizes'


// "inherit" EventEmitter
for (var i in EventEmitter.prototype) {
  prestashop[i] = EventEmitter.prototype[i];
}

// function changeHeaderBGColorOnScroll()
// {
//   if($(document).scrollTop() > 20) {
//     $('#header .header-top').addClass('fadeinwhite');
//   } else {
//     $('#header .header-top').removeClass('fadeinwhite');
//   }
// }

function removeClassStartingWith(node, classStartingWith) {
  node.removeClass (function (index, className) {
      return (className.match ( new RegExp("\\b"+classStartingWith+"\\S+", "g") ) || []).join(' ');
  });
}

function highlightParentCategoryIfInChild()
{
  let parentOfItem = $('#top-menu .menu__item--1.menu__item--current').closest('.menu__item--0');
  parentOfItem.addClass('menu__item--current-parent');
  parentOfItem.find('.menu__item-header .icon-collapse').removeClass('collapsed').attr('aria-expanded','true');
  parentOfItem.find('.menu-sub').addClass('show');
}

const topMenuEl = $('#menu-modal #top-menu');
const topMenu = new TopMenu(topMenuEl);

$(document).ready(() => {
  jQuery.migrateMute = true;
  const form = new Form();
  let slickSlider = new SlickSlider();
  
  form.init();
  slickSlider.init();

  // changeHeaderBGColorOnScroll();
  highlightParentCategoryIfInChild();

  //display input file content in custom file input BS
  $('.custom-file-input').on('change',function(){
      let fileName = $(this).val().split('\\').pop();
      $(this).next('.custom-file-label').addClass("selected").html(fileName);
  })

  $('.menu-opener').on('click', function () {
    $('body').removeClass("modal-open-search");
    $('body').toggleClass("modal-open-menu");
    menu(); 
  });
  $('.search-opener').on('click', function () {
    if ($('body').hasClass('modal-open-search')) {
      $('body').removeClass("modal-open-search");
    } else {
      removeClassStartingWith($('body'), 'modal-open-');
      $('body').addClass("modal-open-search");
    }
  });
  $('.modal-closer').on('click', function () {
    $('body').removeClass("modal-open-menu");
    $('body').removeClass("modal-open-search");
  });
  $('.icon-collapse').on('click', function () {
    $('#top-menu .collapse').collapse('hide');
    $(this).collapse('show');
  });

  if ($('#index').length) {
		homeSlider();
	}

  if ($('#new-promo').length) {
		npSlider();
	}

});

function menu() {

  let windowWithoutScrollWidth = 992 - (window.innerWidth - document.body.clientWidth);

  if ($(document).width() > windowWithoutScrollWidth) {
    
    function resetStateLink() { 
      $("#top-menu > li.menu__item--active").attr('aria-expanded',false).removeClass('menu__item--active').find('.menu-sub').attr('aria-expanded',false);
      $('#menu-modal .menu-columns--column-sub, #menu-modal .menu-columns--column-tags').css('opacity',0);
    };

    if ($('#top-menu > li[class*="menu__item--current"]').length) {
      resetStateLink();
      $('#top-menu > li[class*="menu__item--current"]').attr('aria-expanded',true).addClass('menu__item--active').find('.menu-sub').attr('aria-expanded',true);
      $('#menu-modal .menu-columns--column-sub, #menu-modal .menu-columns--column-tags').css('opacity',1);
    } else {
      // let firstMenuItem = $('#top-menu > li:first-child');
      resetStateLink();
      // firstMenuItem.attr('aria-expanded',true).addClass('menu__item--active').find('.menu-sub').attr('aria-expanded',true);
    }

    var timer;
    $("#top-menu > li.category").mouseover(function(event) {
      var self = $(this);
      clearTimeout(timer);
      timer = setTimeout(function () {
        resetStateLink();
        self.attr('aria-expanded',true).addClass('menu__item--active').find('.menu-sub').attr('aria-expanded',true);
        $('#menu-modal .menu-columns--column-sub, #menu-modal .menu-columns--column-tags').css('opacity',1);
      }, 150);
    }).mouseleave(function(event) {
      // var self = $(this);
      clearTimeout(timer);
      timer = setTimeout(function () {
        resetStateLink();
        if ($('#top-menu > li[class*="menu__item--current"]').length) {
          $('#top-menu > li[class*="menu__item--current"]').attr('aria-expanded',true).addClass('menu__item--active').find('.menu-sub').attr('aria-expanded',true);
          $('#menu-modal .menu-columns--column-sub, #menu-modal .menu-columns--column-tags').css('opacity',1);
        }
        // $("#top-menu > li.menu__item--active").attr('aria-expanded',false).removeClass('menu__item--active').find('.menu-sub').attr('aria-expanded',false);
        // firstMenuItem.attr('aria-expanded',true).addClass('menu__item--active').find('.menu-sub').attr('aria-expanded',true);
      }, 150);
    });

  } else {
    topMenu.init();
  }

}

function homeSlider() {
  $('#carousel ').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    dots: true,
    arrows: true,
    fade: true,
    mobileFirst: true,
    speed: 1000,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          appendArrows: '#desktopControl',
          appendDots: '#desktopControl'
        }
      }
    ]
  });
}

function npSlider() {
  $('#new-promo-slider ').slick({
    infinite: true,
    slidesToShow: 1,
    fade: true,
    slidesToScroll: 1,
    autoplay: false,
    dots: true,
    arrows: true,
    mobileFirst: true,
    speed: 1000,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          appendArrows: '#npControl',
          appendDots: '#npControl'
        }
      }
    ]
  });
}

$(document).ready(function($){			
  var backToTopButton = $('#backToTopButton');			
  $(window).scroll(function () {
    if ($(this).scrollTop() > 600) {
      backToTopButton.addClass("showButton");
    } else {
      backToTopButton.removeClass("showButton");
    }
  });		
});